import React from 'react';
import { Button } from 'semantic-ui-react';
import { useIntl } from 'react-intl';

const CloseButton = ({ disabled, messageId = 'actions.cancel', onClick }) => {
  const intl = useIntl();
  return (
    <Button
      className="aridhia-close-button"
      content={intl.formatMessage({ id: messageId })}
      disabled={disabled}
      onClick={disabled ? undefined : onClick}
    />
  );
};

export default CloseButton;
